"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const sections = [];
    sections.push('**Simulator**\n');
    element.value.items.forEach((item, index) => {
        const stepParts = [];
        if (item.label) {
            stepParts.push(`**Step ${index + 1}: ${item.label}**`);
        }
        if (item.image) {
            const url = (0, md_utils_1.getFileUrl)(item.image, context);
            if (url) {
                stepParts.push(`![Simulator Step](${url})`);
            }
        }
        if (item.areas && item.areas.length > 0) {
            const hints = [];
            item.areas.forEach((area) => {
                var _a;
                if ((_a = area.hint) === null || _a === void 0 ? void 0 : _a.text) {
                    const hintText = (0, rich_text_1.slateToMarkdown)(area.hint.text, {
                        allowHtmlStyles: context.withStyle,
                        allowAlignment: context.withStyle,
                        allowCaptionHtml: context.withStyle,
                    }).trim();
                    if (hintText) {
                        hints.push(`- ${hintText}`);
                    }
                }
            });
            if (hints.length > 0) {
                stepParts.push('Hints:');
                stepParts.push(...hints);
            }
        }
        if (stepParts.length > 0) {
            sections.push(stepParts.join('\n'));
        }
    });
    if (sections.length === 1) {
        return '';
    }
    return sections.join('\n\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
